import { z } from "zod";

const VALIDATION_MESSAGE = {
	canceledPrice: "キャンセル料金は0円以上で入力してください",
};

export const ReservationDetailCancelInputZodSchema = z.object({
	canceledPrice: z
		.number()
		.nonnegative({ message: VALIDATION_MESSAGE.canceledPrice })
		.optional() // undefined 時に、カスタムエラーとしたいので optional にしている
		.transform((value, ctx) => {
			if (value === undefined) return ctx.addIssue({ code: "custom", message: VALIDATION_MESSAGE.canceledPrice });
			return value;
		}),
});

export type ReservationDetailCancelInputType = z.infer<typeof ReservationDetailCancelInputZodSchema>;
